import React from "react";
import { Popover as PopoverPrimitive } from "radix-ui";

const NAME = "PopoverAnchor";

export type PopoverAnchorProps = PopoverPrimitive.PopoverAnchorProps;

export const PopoverAnchor = (props: PopoverAnchorProps) => (
  <PopoverPrimitive.Anchor {...props}>{props.children}</PopoverPrimitive.Anchor>
);

PopoverAnchor.displayName = NAME;
